// model based on API::V1::Activity::V1::ProfileSerializer
export default {

  // Images
  background_image: null,
  profile_image: null,
  gradient_start: null,
  gradient_end: null,

  // Attributes
  identifier: null,
  label: null,
  headline: null,
  subheadline: null,
  content: null
}
